import React from "react";
import { Chip, Tooltip, makeStyles } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useSelector } from "src/redux/store";

const useStyles = makeStyles({
  "@keyframes tmoRecPulse": {
    "0%, 100%": { opacity: 1, transform: "scale(1)" },
    "50%": { opacity: 0.55, transform: "scale(0.96)" },
  },
  rec: {
    backgroundColor: "#ef4444",
    color: "white",
    fontWeight: 800,
    fontSize: 11,
    letterSpacing: 0.5,
    cursor: "pointer",
    animation: "$tmoRecPulse 1.6s infinite",
  },
});

/**
 * Pastilla "● REC" parpadeante en el TopBar cuando la monitorización
 * global está activa (en cualquier dispositivo del restaurante).
 * Click → abre la vista del monitor. Transparencia: el cliente final
 * SIEMPRE ve que se le está grabando, no es vigilancia oculta.
 */
export default function RecBadge() {
  const isMonitoring = useSelector((s) => s.errors?.isMonitoring);
  const history = useHistory();
  const classes = useStyles();

  if (!isMonitoring) return null;

  return (
    <Tooltip title="Monitorización ACTIVA — se están grabando peticiones, latencias y caídas. Click para abrir el panel." arrow>
      <Chip
        size="small"
        label="● REC"
        onClick={() => history.push("/app/userNormal/monitor")}
        className={classes.rec}
      />
    </Tooltip>
  );
}
